import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import * as amplitude from '@amplitude/analytics-browser';

import { REACH_PAGE_EVENTS } from '@app/dashboard/constants/tracking_events/reach';
import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import { fetchCurrentPlan } from '@app/dashboard/services/inner_layout/reach/bundles';

import Header from './Header';
import Plans from './Plans';

import styles from './Bundles.module.scss';

const Bundles = () => {
  const { data: currentPlan = {} } = useQuery({
    queryKey: [QUERY_KEYS.REACH_GET_CURRENT_PLAN],
    queryFn: fetchCurrentPlan,
    select: (data) => data.data?.data?.last_sms_subscibed_plans_history,
  });

  useEffect(() => {
    amplitude.track(REACH_PAGE_EVENTS.BUNDLES_PAGE.VIEW_BUNDLES_PAGE);
  }, []);

  return (
    <div className={styles['bundles']}>
      <Header currentPlan={currentPlan} />
      <Plans currentPlan={currentPlan} />
    </div>
  );
};

export default Bundles;
